/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration for detecting when fields are deleted.
 * @export
 * @interface FieldDeletedEvent
 */
export interface FieldDeletedEvent {
    /**
     * If always, the integration will monitor for deleted fields by default.
     * @type {string}
     * @memberof FieldDeletedEvent
     */
    enabled: FieldDeletedEventEnabledEnum;
}


/**
 * @export
 */
export const FieldDeletedEventEnabledEnum = {
    Always: 'always'
} as const;
export type FieldDeletedEventEnabledEnum = typeof FieldDeletedEventEnabledEnum[keyof typeof FieldDeletedEventEnabledEnum];


/**
 * Check if a given object implements the FieldDeletedEvent interface.
 */
export function instanceOfFieldDeletedEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function FieldDeletedEventFromJSON(json: any): FieldDeletedEvent {
    return FieldDeletedEventFromJSONTyped(json, false);
}

export function FieldDeletedEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldDeletedEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function FieldDeletedEventToJSON(value?: FieldDeletedEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

